import { useSyncExternalStore } from 'react';

export const useMediaQuery = (
  query: string,
  initState?: boolean
): boolean | undefined => {
  return useSyncExternalStore(
    (onStoreChange) => {
      const mql = window.matchMedia(query);
      if (!mql) return () => undefined;
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', onStoreChange);
        return () => mql.removeEventListener('change', onStoreChange);
      }
      // Fallback for older browsers (addListener is deprecated)
      if (typeof mql.addListener === 'function') {
        mql.addListener(onStoreChange);
        return () => mql.removeListener?.(onStoreChange);
      }
      return () => undefined;
    },
    // Client snapshot
    () => window.matchMedia(query).matches,
    // Server snapshot
    () => initState
  );
};
